module.exports = __webpack_public_path__ + "static/media/google-assistant.b9c7a710.png";